import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface StatsLineItem {
  label: string;
  value: number;
  icon: LucideIcon;
  accentClass?: string;
}

interface StatsLineProps {
  items: StatsLineItem[];
}

export default function StatsLine({ items }: StatsLineProps) {
  return (
    <div className="card px-4 py-3">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
        {items.map((item) => (
          <div key={item.label} className="flex items-center gap-2">
            <item.icon className={cn('h-4 w-4', item.accentClass || 'text-prima-600')} />
            <span className="text-sm font-semibold text-gray-900">{item.value}</span>
            <span className="text-sm text-gray-500">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
